import React from 'react';
import { REPORT_COLUMNS } from '../constants';
import ReportTableRow from './ReportTableRow';
import * as Style from '../styles';

function ReportTable({ rows, onSssgClick, columns = REPORT_COLUMNS }) {
    return (
        <Style.Table>
            <Style.TableHeadRow>
                {columns.map(column => (
                    <Style.TableCell
                        key={column.key}
                        width={column.width}
                        align={column.align}
                        sticky={column.key === 'nome'}
                        background="#424242"
                    >
                        <Style.TableHeadCellText>
                            {column.label}
                        </Style.TableHeadCellText>
                    </Style.TableCell>
                ))}
            </Style.TableHeadRow>

            {rows.map(row => (
                <ReportTableRow
                    key={row.id}
                    row={row}
                    columns={columns}
                    onSssgClick={onSssgClick}
                />
            ))}
        </Style.Table>
    );
}

export default ReportTable;
